module.exports = __webpack_public_path__ + "img/优耐德.95fc1ba5.png";